class JCCatalogCompareList {
  constructor(params) {
    this.obCompare = null;
    this.obAdminPanel = null;
    this.visual = params.VISUAL;
    this.ajax = params.AJAX;

    this.init();
  }

  init() {
    this.obCompare = document.getElementById(this.visual.ID);
    if (this.obCompare) {
      document.addEventListener('OnCompareChange', this.reload);

      this.obCompare.addEventListener('click', (evt) => {
        if (evt.target.tagName === 'a') {
          this.deleteCompare();
        }
      });
    }
  }

  async reload() {
    try {
      const rawResponse = await fetch(this.ajax.url, {
        method: 'POST',
        body: this.ajax.reload,
      });
      const response = await rawResponse.text();
      this.reloadResult(response);
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
    }
  }

  reloadResult(result) {
    if (!result) {
      window.showError();
    }

    this.obCompare.innerHTML = result;
    const compareParent = this.obCompare.parentNode;

    if (compareParent.classList.contains('checked')) {
      const compareProductPopup = document.querySelector('[data-list-type=jsCompareProduct]');

      if (compareProductPopup) {
        setTimeout(() => {
          compareProductPopup.classList.add('_with-popup--active');
        }, 100);

        const timeout = setTimeout(() => {
          compareProductPopup.classList.remove('_with-popup--active', 'checked');
        }, 2100);

        compareProductPopup.addEventListener('mouseover', () => {
          clearTimeout(timeout);
        });
      }
    }
  }

  async deleteCompare(target) {
    if (target && target.hasAttribute('data-id')) {
      const itemID = parseInt(target.getAttribute('data-id'), 10);

      if (!Number.isNaN(itemID)) {
        const URL = this.ajax.url + this.ajax.templates.delete + itemID.toString();

        try {
          const rawResponse = await fetch(`${URL}?${new URLSearchParams(this.ajax.params)}`);
          const response = await rawResponse.json();
          this.deleteCompareResult(response);
        } catch (err) {
          // eslint-disable-next-line
          console.error(err);
        }
      }
    }
  }

  deleteCompareResult(result) {
    if (!result) {
      window.showError();
    }

    if (result.STATUS && result.STATUS === 'OK' && result.ID) {
      // TODO: ПРОВЕРИТЬ! Вот тут в событие передается параметр [result.ID], возможно будет ошибка
      const event = new CustomEvent('onCatalogDeleteCompare');
      document.body.dispatchEvent(event);

      if (result.COUNT === 0) {
        const compareProductPopup = document.querySelector('[data-list-type=jsCompareProduct]');
        compareProductPopup.classList.remove('_with-popup--active', 'checked');
      }

      this.reload();
    }
  }
}

window.JCCatalogCompareList = JCCatalogCompareList;

// window.JCCatalogCompareList = function (params) {

// }
